import { baseClasses } from '@weatherbug/common';

const { AsyncAction } = baseClasses;

export const GET_NOTIFICATIONS = new AsyncAction('GET_NOTIFICATIONS');

export type StateType = {
    alertsDataLoadError: boolean;
}

const initialState: StateType = {
    alertsDataLoadError: false
};

type NotificationActionType = {
    type: typeof GET_NOTIFICATIONS.pending | typeof GET_NOTIFICATIONS.fulfilled | typeof GET_NOTIFICATIONS.rejected;
    payload: Record<string, unknown>;
};

export function alertsPage(state = initialState, action: NotificationActionType): StateType
{
    switch (action.type)
    {
        case GET_NOTIFICATIONS.pending:
        {
            return {
                ...state,
                alertsDataLoadError: false
            };
        }

        case GET_NOTIFICATIONS.fulfilled:
        {
            return {
                ...state,
                alertsDataLoadError: false
            };
        }

        case GET_NOTIFICATIONS.rejected:
        {
            return {
                ...state,
                alertsDataLoadError: true
            };
        }
        default: 
        {
            return state;
        }
    }
}
